import { useRef, useState, useEffect, ComponentProps } from 'react';
import { styled } from 'styled-components';
import { Outlet } from 'react-router';
import { Header as DefHeader } from '../components/Header';
import { MobileSidebarMenu } from '../components/misc';

export type LayoutWithHeaderProps = {} & ComponentProps<typeof Wrapper>;

const LayoutWithHeader = (props: LayoutWithHeaderProps) => {
  const headerRef = useRef<HTMLDivElement>(null);

  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    const headerElement = headerRef.current;

    if (headerElement) {
      const updateHeight = () => {
        setHeaderHeight(headerElement.offsetHeight);
      };

      const resizeObserver = new ResizeObserver(() => {
        updateHeight();
      });

      resizeObserver.observe(headerElement);

      updateHeight();

      return () => {
        resizeObserver.disconnect();
      };
    }
  }, []);

  return (
    <Wrapper {...props}>
      <MobileSidebarMenu />
      <Header ref={headerRef} />
      <Outlet context={{ headerHeight }} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  @supports (min-height: 100dvh) {
    min-height: 100dvh;
  }
`;

const Header = styled(DefHeader)`
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;

  ${({ theme }) => theme.getUpMedia('md')} {
    position: static;
  }
`;

export { LayoutWithHeader };
